"use client";

import type { SecurityHeroSectionQueryResult } from "@/sanity/schemas/lib/queries";
import Image from "next/image";

interface SecurityHeroSectionProps {
    sanityContent: SecurityHeroSectionQueryResult;
}

export function SecurityHeroSection({ sanityContent }: SecurityHeroSectionProps) {
    return (
        <section
            data-scroll-dock-trigger
            className="relative bg-[#020506fa] min-h-[630px] md:min-h-[850px]  text-white "
        >
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 flex items-center justify-center"
            ></div>

            <div className="relative z-10 mx-auto max-w-7xl pt-40 px-5 md:px-20">
                <div className="max-w-[375] md:max-w-[604px] pb-5">
                    <h1 className="text-[26px] md:text-[48px] max-h-[604px] font-semibold leading-120">
                        {sanityContent.title}
                    </h1>
                    <p className="mt-6 md:mt-8 text-subtitle text-white/70 leading-140">
                        {sanityContent.subtitle}
                    </p>
                </div>
            </div>

            <Image
                src="/images/security-hero-img.svg"
                alt="security-hero-img"
                priority
                fill
                className=" object-right pointer-events-none opacity-70"
            />
            <Image
                src="/images/services-ellipse.svg"
                alt="securityBG"
                priority
                fill
                className="
                    absolute pointer-events-none
                    w-full    
                    top-7
                    md:bottom-0 md:top-0
                    
                    max-w-none min-w-[1440px] md:min-w-[1920px]
                    translate-y-[380px] min-[767px]:translate-y-[520px]   min-[2000px]:translate-y-[380px]
                    
                    [mask-image:linear-gradient(to_bottom,transparent_0%,black_10%)]
                "
            />
        </section>
    );
}
